'use strict'

import React      from 'react'
import $          from 'jquery'
import Calculator from '../assets/calculator'

export default class FormLanding extends React.Component {
  constructor () {
    super()

    this.topClick = this.topClick.bind(this)
  }

  topClick () {
    $('#next-page').click()

    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Step 1',
      eventLabel: 'Start - Top'
    })
  }

  render () {
    return (
      <section className="form-landing">
        <div className="container">
          <div className="row">
            <div className="">
              <h2 className="header outline">Welcome</h2>
              <p className="align-center">
                We're here to help you take the next steps towards a confident new smile. Don’t put off any longer.
              </p>
              <div className="landing-info">
                <div>
                  <span>Confidential</span><span>Tailored</span><span>Flexible</span>
                </div>
                <span className="align-center">Don't worry you are not alone, over 35,000 patients have been helped by Dental Members Australia.</span>
              </div>
              <div className=''>
                <div className='step-counter'>
                  Step 1 of 4
                </div>
                <button
                  className='next-page-button'
                  onClick={this.topClick}
                  >
                  START
                </button>
              </div>
              <p>
                A few innovative dentists, a heartfelt desire to make quality dentistry affordable to all, an inspired idea – affordable dental plan.
              </p>
              <p>
                Dental Members Australia's (DMA) mission is to make visiting the dentist affordable and accessible. We want to help the 70% of Australians in need of dental care.
              </p>
              <p>
                Rather than paying for your dental treatment upfront you can now use one of our Dental Vouchers ($1000 to $5000) and pay for your treatment in:
              </p>
              <ul>
                <li>
                  0% interest.
                </li>
                <li>
                  No credit checks.
                </li>
                <li>
                  No lock in contracts / Cancel anytime.
                </li>
                <li>
                  Save up to 10% on all dental procedures. ***
                </li>
                <li>
                  The only cost to you is a one-off $38 registration fee.
                </li>
              </ul>

              <Calculator
                onChange={this.props.onChange}
                showButton={false}
                amount={
                  this.props.summary['dental-package']
                  ? Number(this.props.summary['dental-package'].weeklyPayment.replace(/[^0-9\.]+/g, ''))
                  : 0
                }
                package={
                  this.props.summary['dental-package']
                  ? [1000, 2000, 3000, 4000, 5000, 10000].indexOf(Number(this.props.summary['dental-package'].value.replace(/[^0-9\.]+/g, '')))
                  : 0
                }
                />
            </div>

          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/form-landing.js